var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Select',{attrs:{"name":_vm.name,"options":_vm.items,"reduce":item => item.value,"multiple":_vm.multiple,"placeholder":_vm.placeholder,"rules":_vm.rules},on:{"search":_vm.search},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }